import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { RECONNECTION_CONFIG } from "config/reconnectionConfig";

interface ReconnectionDialogProps {
  visible: boolean;
  disconnectDuration: number; // 밀리초
  onReconnect: () => void;
  onCancel: () => void;
}

const ReconnectionDialog: React.FC<ReconnectionDialogProps> = ({
  visible,
  disconnectDuration,
  onReconnect,
  onCancel,
}) => {
  const { t } = useTranslation();
  const [countdown, setCountdown] = useState(
    Math.floor(RECONNECTION_CONFIG.DIALOG_AUTO_CANCEL_TIMEOUT / 1000)
  );

  useEffect(() => {
    if (!visible) {
      setCountdown(
        Math.floor(RECONNECTION_CONFIG.DIALOG_AUTO_CANCEL_TIMEOUT / 1000)
      );
      return;
    }

    // 카운트다운
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          console.log("Dialog timeout - auto canceling");
          onCancel();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [visible, onCancel]);

  if (!visible) return null;

  const disconnectSeconds = Math.floor(disconnectDuration / 1000);

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="w-[90%] max-w-md bg-gray-800 rounded-2xl p-6 shadow-2xl border border-gray-700">
        {/* Icon */}
        <div className="text-center mb-4">
          <div className="text-6xl">🔌</div>
        </div>

        {/* Title */}
        <h2 className="text-2xl font-bold text-white text-center mb-3">
          {t("reconnectionDialog.title")}
        </h2>

        {/* Message */}
        <div className="text-center text-gray-300 mb-2">
          <p className="mb-2">
            {t("reconnectionDialog.message1")}{" "}
            <span className="font-bold text-red-400">
              {disconnectSeconds}
              {t("reconnectionDialog.seconds")}
            </span>{" "}
            {t("reconnectionDialog.message2")}
          </p>
          <p>{t("reconnectionDialog.question")}</p>
        </div>

        {/* Countdown */}
        <div className="text-center text-sm text-gray-500 mb-4">
          {countdown}
          {t("reconnectionDialog.autoCancel")}
        </div>

        {/* Buttons */}
        <div className="flex gap-3">
          <button
            onClick={onReconnect}
            className="flex-1 py-3 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-lg transition-colors"
          >
            {t("reconnectionDialog.reconnect")}
          </button>
          <button
            onClick={onCancel}
            className="flex-1 py-3 bg-gray-700 hover:bg-gray-600 text-white font-bold rounded-lg transition-colors"
          >
            {t("reconnectionDialog.leave")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReconnectionDialog;
